import { render, staticRenderFns } from "./HelpCircle.vue?vue&type=template&id=1413de74&scoped=true&"
import script from "./HelpCircle.vue?vue&type=script&lang=js&"
export * from "./HelpCircle.vue?vue&type=script&lang=js&"
import style0 from "./HelpCircle.vue?vue&type=style&index=0&id=1413de74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1413de74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
